import { render, staticRenderFns } from "./MultiImgUploader.vue?vue&type=template&id=2e79ca7e&scoped=true"
import script from "./MultiImgUploader.vue?vue&type=script&lang=js"
export * from "./MultiImgUploader.vue?vue&type=script&lang=js"
import style0 from "./MultiImgUploader.vue?vue&type=style&index=0&id=2e79ca7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79ca7e",
  null
  
)

export default component.exports